/* eslint-disable no-underscore-dangle */

xplenty.controller('WorkflowOperatorStep', [
  '$scope',

  function ($scope) {
    $scope.hasOperator = $scope.$parent.$parent._default.inputEdges.length > 1;

    $scope.packageOperatorStep = $scope.$parent.createStep(
      'Execute task if',
      'Choose task execution',
      '<workflow-operator-editor></workflow-operator-editor>',
    );

    $scope.packageOperatorStep.lock = false;
    $scope.packageOperatorStep.valid = !$scope.packageOperatorStep.lock;
    $scope.packageOperatorStep.hide = $scope.packageOperatorStep.lock;

    $scope.$watch('component.operator', function (operator) {
      if (operator === 'and') {
        $scope.packageOperatorStep.tags = [
          {
            name: 'all preceding conditions evaluate to true (AND)',
          },
        ];
      } else if (operator === 'or') {
        $scope.packageOperatorStep.tags = [
          {
            name: 'one of the preceding conditions evaluate to true (OR)',
          },
        ];
      } else {
        $scope.packageOperatorStep.tags = [];
      }
    });
  },
]);
